import { ModelConstants } from 'shell-models-lib';

export class WorkspaceUtils {

    public static defaultStorageLinkedServiceSuffix: string = '-WorkspaceDefaultStorage';
    public static defaultSqlServerLinkedServiceSuffix: string = '-WorkspaceDefaultSqlServer';
    public static linkedServicesSuffix: string = 'linkedservices';
    public static linkedServiceSuffix: string = 'linkedService';
    public static defaultSqlServerConnectionStringPrefix: string = 'Data Source=tcp:';
    public static defaultSqlServerConnectionStringSuffix: string = '.sql.azuresynapse.net,1433;Initial Catalog=@{linkedService().DBName}';

    // Returns true if the Linked Service is a default LS.
    public static isWorkspaceDefaultLinkedService(linkedServiceType: string, linkedServiceName: string, workspaceName: string): boolean {
        return linkedServiceType === ModelConstants.adlsGen2LinkedService && linkedServiceName === `${workspaceName}${WorkspaceUtils.defaultStorageLinkedServiceSuffix}`
            || linkedServiceType === ModelConstants.synapseLinkedService && linkedServiceName === `${workspaceName}${WorkspaceUtils.defaultSqlServerLinkedServiceSuffix}`;
    }
}
